import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { getUserNameToName, formatData } from '../../../../utils/util';
import AreaService from '../../../../services/AreaService';

const AreaConversionListItem = (props) => {
    const { data } = props;
    return (
        <div>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', right: '15px', zIndex: '999', marginTop: '8px' }}
            >
                <i className="material-icons small sixth-text-color"
                    onClick={() => props.onClickEdit(data)}
                    style={{ cursor: 'pointer' }}>edit</i>
            </span>
            <span
                className="title sixth-text-color right"
                style={{ position: 'absolute', right: '15px', zIndex: '999', marginTop: '50px' }}
            >
                <i className="material-icons small sixth-text-color"
                    onClick={() => props.onClickDelete(data)}
                    style={{ cursor: 'pointer' }}>delete</i>
            </span>
            <div
                style={{ display: 'block' }}
            >
                <span className="title sixth-text-color">
                    <i /> {`${data.areaFrom}`}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-arrow-right" /> {data.areaTo}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i /> <i className="mdi mdi-history" /> {formatData(props.data.updateOn)}
                </span>
                <span className="truncate second-text-color" style={{ marginLeft: '10px' }}>
                    <i className="mdi mdi-account" /> {getUserNameToName(props?.usersFromElog, props.data.updateBy)}
                </span>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        area: state.areaReducer.area,
        usersFromElog: state.usersElogReducer.usersElog
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        areaDelete: (area, callback) => {
            dispatch(AreaService.DeleteArea(area.areaId, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AreaConversionListItem)));
